export interface CustomerSearchTotalsDTO {
  customerId: string;
  customerName: string;
  customerEmail: string;
  searchCount: number;
  latestSearchDate?: Date;
  isOpen?: boolean;
}
